import { useState } from 'react'
import { IconSvg } from 'components/common'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface AgeRestrictModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	ageLimit?: number | null
}

export function AgeRestrictModal({ open, setOpen, ageLimit }: AgeRestrictModalProps) {
	return (
		<ContentModal
			open={open}
			setOpen={setOpen}
			isModal
			className="z-50"
			hideCloseButton={false}
		>
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[400px] text-center">
					<div className="flex justify-center mb-4">
						<div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center">
							<IconSvg icon="user" width={32} height={32} className="text-red-500" />
						</div>
					</div>
					<h3 className="text-2xl font-bold mb-4">Age Restricted</h3>
					<div className="text-lg text-primary-text mb-2">
						{ageLimit
							? `You must be ${ageLimit}+ to attend this event.`
							: 'You do not meet the age requirement for this event.'}
					</div>
					<div className="text-sm text-secondary-text italic mt-4">
						Please verify your age in your profile settings or contact the event organizer for assistance.
					</div>
				</div>
				<button
					type="button"
					className="px-6 rounded-3xl text-center transition-all duration-300 bg-primary text-white font-bold block w-full h-10 shadow-button backdrop-blur-lg hover:bg-primary-hover"
					onClick={() => setOpen(false)}
				>
					OK
				</button>
			</div>
		</ContentModal>
	)
}

export interface AgeRestrictModalManagedProps {
	ageLimit?: number | null
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'age-restrict': AgeRestrictModalManagedProps
	}
}

export function ManagedAgeRestrictModal({
	onClose,
	...rest
}: AgeRestrictModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<AgeRestrictModal
			open={open}
			setOpen={(v: boolean) => {
				if (!v) handleClose()
			}}
			{...rest}
		/>
	)
}
